import { Component, OnInit } from '@angular/core';
import { faCommentAlt, faUserTie, faPhoneAlt, faAt, faMicrophone } from '@fortawesome/free-solid-svg-icons';

@Component({
    selector: 'app-contactus',
    templateUrl: './contactus.component.html',
    styleUrls: ['./contactus.component.less'],
    standalone: false
})
export class ContactusComponent implements OnInit {

  faCommentAlt=faCommentAlt;
  faUserTie=faUserTie;
  faPhoneAlt=faPhoneAlt;
  faAt=faAt;
  faMicrophone=faMicrophone;

  constructor() { }

  ngOnInit() {
  }

}
